import { render, staticRenderFns } from "./DfiFieldWrapper.vue?vue&type=template&id=1866f8a0&scoped=true&"
import script from "./DfiFieldWrapper.vue?vue&type=script&lang=ts&"
export * from "./DfiFieldWrapper.vue?vue&type=script&lang=ts&"
import style0 from "./DfiFieldWrapper.vue?vue&type=style&index=0&id=1866f8a0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1866f8a0",
  null
  
)

export default component.exports